// src/icons/NotEye.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function NotEye() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M1 14L15 2",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.5 7.99986C1.5 7.17871 2.17312 6.0791 3.46017 5.13192C4.7117 4.21088 6.37168 3.57129 8 3.57129C9.61784 3.57129 11.2669 4.20267 12.5156 5.11417L13.6804 4.11579C13.5977 4.05032 13.5138 3.9863 13.4289 3.92381C11.9617 2.84404 9.99667 2.07129 8 2.07129C6.00332 2.07129 4.0383 2.84404 2.57108 3.92381C1.13938 4.97744 0 6.46711 0 7.99986C0 9.5326 1.13938 11.0223 2.57108 12.0759C2.89623 12.3152 3.24581 12.5394 3.61478 12.7435L4.84569 11.6884C4.34877 11.4558 3.88134 11.1778 3.46017 10.8678C2.17312 9.92062 1.5 8.82101 1.5 7.99986ZM6.48982 12.2547L5.1284 13.4217C6.04079 13.741 7.01656 13.9284 8 13.9284C9.99667 13.9284 11.9617 13.1557 13.4289 12.0759C14.8606 11.0223 16 9.5326 16 7.99986C16 6.99641 15.5117 6.01143 14.7727 5.15516L13.6346 6.13069C14.2058 6.79245 14.5 7.457 14.5 7.99986C14.5 8.82101 13.8269 9.92062 12.5398 10.8678C11.2883 11.7888 9.62832 12.4284 8 12.4284C7.49528 12.4284 6.98752 12.367 6.48982 12.2547ZM10.7583 8.59603C10.4961 9.81498 9.44641 10.7413 8.16793 10.8164L10.7583 8.59603ZM10.5527 6.79664C10.1011 5.84021 9.12785 5.17843 8 5.17843C6.44177 5.17843 5.17857 6.44163 5.17857 7.99986C5.17857 8.97302 5.67126 9.83111 6.42081 10.3383L7.6591 9.2769C7.09451 9.12657 6.67857 8.61179 6.67857 7.99986C6.67857 7.27006 7.2702 6.67843 8 6.67843C8.68203 6.67843 9.24338 7.19514 9.31395 7.85845L10.5527 6.79664Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}

export {
  NotEye
};
